import { PICTURES_Z_INDEX } from "./constants";

const getStyleZIndex = (feature, isPicture = false) => {
  // A feature-controlled `zIndex` property (set from MultiFeaturesDialog's
  // drag-and-drop reorder or from FeatureStyler) always takes precedence
  // over the geometry-based default. Negative values are allowed so the
  // user can push a feature below the geometry defaults.
  //
  // Coerce with Number(...) because ol's KML reader hands us strings for
  // ExtendedData values; `Number.isFinite` alone would reject those.
  const featureZIndex = Number(feature?.get?.("zIndex"));
  if (Number.isFinite(featureZIndex)) {
    return featureZIndex;
  }

  /* We always set zIndices when editing features for backwards compatibility */
  if (isPicture) {
    return PICTURES_Z_INDEX;
  }

  return 0;
};

export default getStyleZIndex;
